<template lang="">
  <el-dialog
    :title="'个人设置' | translateTo"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="popupClose"
    custom-class="update-profile-dialog"
    width="30%"
  >
    <el-form :model="pfModel" ref="form" :rules="rules" status-icon>
      <el-form-item :label="'姓名' | translateTo" prop="name">
        <el-input v-model="pfModel.name" autocomplete="name"></el-input>
      </el-form-item>
      <!-- <div class="email-wrap">
        <el-form-item label="邮箱地址" prop="email">
          <el-input type="email" v-model="pfModel.email" autocomplete="email"></el-input>
        </el-form-item>
        <el-form-item label="" prop="verifyCode" class="custom-order">
          <el-input v-model="pfModel.verifyCode" placeholder="验证码"></el-input>
          <el-button :disabled="sendingBtnState" @click="sendEmailCode">
            {{ sendingBtnText }}
          </el-button>
        </el-form-item>
      </div>
      <el-form-item prop="emailAlarm">
        <el-checkbox v-model="pfModel.emailAlarm">开启邮件报警接收</el-checkbox>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="popupClose()">{{ 'cancel' | translateTo }}</el-button>
      <el-button type="primary" @click="modifyProfile" v-loading="loading">
        {{ 'confirm' | translateTo }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { modifyProfile, sendEmailCode } from '@/api/auth';
import store from '@/store';
import { mapState } from 'vuex';
import { translateTo } from '@/utils/locale';
import { isEmpty } from '@/utils/is';

const validateEmail = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(translateTo('请输入邮箱')));
  } else if (
    /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(value)
  ) {
    callback();
  } else {
    callback(translateTo('请输入正确的邮箱'));
  }
};

export default {
  name: 'updateProfile',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      sendingBtnState: false,
      sendingBtnText: '获取验证码',
      timer: null,
      record: {
        email: '',
        verifyCode: ''
      },
      pfModel: {
        id: '',
        name: '',
        email: '',
        emailAlarm: '',
        verifyCode: ''
      },
      rules: {
        name: [
          {
            required: true,
            validator: (_rule, value, callback) => {
              if (isEmpty(value)) {
                callback(translateTo('请输入用户名'));
              } else {
                callback();
              }
            }
          }
        ]
        // email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        // verifyCode: [{ required: true, message: '请输入验证码' }]
      }
    };
  },
  computed: {
    ...mapState('admin', ['userInfo'])
  },
  methods: {
    setVisibility(val) {
      this.$emit('update:visible', val);
    },
    sendEmailCode() {
      if (this.sendingBtnState) return;
      validateEmail(null, this.pfModel.email, msg => {
        if (msg) throw msg;
        const { email } = this.pfModel;
        this.disableBtn();
        sendEmailCode({ email }).then(res => {
          if (res.code === 200) {
            this.record.verifyCode = res.data;
          }
        });
      });
    },
    disableBtn() {
      this.sendingBtnState = true;
      this.record.email = this.pfModel.email;
      let num = 60;
      this.sendingBtnText = num;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (num-- <= 1) {
          this.enableBtn();
        } else {
          this.sendingBtnText = num;
        }
      }, 1000);
    },
    enableBtn() {
      clearInterval(this.timer);
      this.sendingBtnText = '获取验证码';
      this.sendingBtnState = false;
    },
    modifyProfile() {
      const { id, name } = this.pfModel;
      // if (verifyCode !== this.record.verifyCode || this.record.email !== email) {
      //   this.$message({
      //     type: 'warning',
      //     message: '验证码错误'
      //   });
      //   return;
      // }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          // modifyProfile({ id, name, email, emailAlarm: String(+emailAlarm) })
          modifyProfile({ id, name })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: res.message
                });
                store.dispatch('admin/getUserInfo');
              }
            })
            .finally(() => {
              this.popupClose();
            });
        } else {
          return false;
        }
      });
    },
    popupClose() {
      this.$refs.form.resetFields();
      this.setVisibility(false);
      this.enableBtn();
      this.loading = false;
    }
  },
  watch: {
    visible(n) {
      if (n) {
        const { id, name, email, emailAlarm } = this.userInfo;
        Object.assign(this.pfModel, { id, name, email, emailAlarm: Boolean(+emailAlarm) });
      }
    }
  }
};
</script>
<style lang="scss">
.update-profile-dialog {
  .email-wrap {
    display: flex;
    align-items: flex-end;
    .el-form-item:nth-of-type(1) {
      width: 85%;
    }
  }
  .custom-order {
    .el-form-item__content {
      display: flex;
      width: 100%;
      .el-input {
        border-radius: 4px 0 0 4px;
      }
      .el-button {
        border-radius: 0 4px 4px 0;
      }
    }
  }
}
</style>
